module.exports = __webpack_public_path__ + "img/iv_b2_pic2.658e071c.png";